import { isMobileScreen, formatCurrency } from '../../../../';
import { formatDate } from '../../../../../../../apps/admin/src/common/SharedFunctions';
interface HeaderPanelLeftProps {
    drawTotal: number;
    businessName?: string;
    propertyAddress?: string;
    drawCount?: number;
    latestDrawCreatedDate?: Date;
}

export const HeaderPanelLeft = ({
    drawTotal,
    businessName,
    propertyAddress,
    drawCount,
    latestDrawCreatedDate,
}: HeaderPanelLeftProps): JSX.Element => {
    // Checking window width to apply mobile style
    const mobileScreen = isMobileScreen();
    const drawNumber = drawCount ? `#${drawCount}` : '';
    return (
        // <div className="draw-header">
        <div className='draw-header-left'>
            <table className='draw-header-table'>
                <tbody>
                    {!mobileScreen && (
                        <tr>
                            <td colSpan={3}>{businessName ? businessName : '-'}</td>
                        </tr>
                    )}
                    <tr>
                        <td colSpan={3}>{propertyAddress ? propertyAddress : '-'}</td>
                    </tr>
                    {!mobileScreen && (
                        <>
                            <tr>
                                <td>Draw No:</td>
                                <td align='center'>{drawNumber}</td>
                            </tr>
                            <tr>
                                <td>Date:</td>
                                <td align='center'>{latestDrawCreatedDate && formatDate(latestDrawCreatedDate)}</td>
                            </tr>
                            <tr>
                                <td>Draw Total:</td>
                                <td align='center'>{drawTotal ? formatCurrency(drawTotal, 2) : '-'}</td>
                            </tr>
                        </>
                    )}
                </tbody>
            </table>
        </div>
        // </div>
    );
};
